import { createSlice } from "@reduxjs/toolkit";

const initalRepórts = {
  params: {
    page: 1,
    limit: 15,
  },
  search: {},
  columnsTributation: [],
  isUpdateColumns: false,
};

const initialState = () => {
  return {
    ...initalRepórts,
  };
};

export const relatorioCfopSlice = createSlice({
  name: "productReportsInvoices",
  initialState,
  reducers: {
    handleParams: (state, { payload }) => {
      const field = payload?.field;
      const value = payload?.value;
      state.params[field] = value;
    },

    handleParamsClear: (state, { payload }) => {
      const field = payload?.field;
      delete state.search[field];
      return state;
    },
    handleParamsClearIn: state => {
      state.search = {};
      return state;
    },
    handleParamsSearch: (state, { payload }) => {
      const field = payload?.field;
      const value = payload?.value;
      state.search[field] = value;
    },
    handleSetColumnsTributation: (state, { payload }) => {
      const columns = payload;
      state.columnsTributation = columns;
    },
    handleOnChangeColumns: (state, { payload }) => {
      const { name, omit } = payload;
      const actions = state.columnsTributation.filter(
        item => !item.name && item.disabledDrop,
      );
      const selected = state.columnsTributation
        .filter(
          item =>
            item.name && !item.disabledDrop && (item.id ?? item.name) === name,
        )
        .map(item => {
          return {
            ...item,
            omit: !omit ? true : false,
          };
        });

      const others = state.columnsTributation.filter(
        item =>
          item.name && !item.disabledDrop && (item.id ?? item.name) !== name,
      );

      const newList = [...actions, ...selected, ...others];

      const listPositions = newList.sort(
        (itemA, itemB) => itemA.position - itemB.position,
      );
      state.columnsTributation = listPositions;
    },
    // Só troca `omit`, preservando `position` — diferente de
    // handleReorderAndUpdateColumns (que recalcula position pelo índice do
    // array, correto pro drag-and-drop do relatório antigo, mas destrutivo
    // no RelatorioProdutosNovo, cujas posições têm "buracos" entre grupos —
    // ver tributeGroups.js).
    handleToggleColumnsOmit: (state, { payload }) => {
      const omitMap = {};
      payload.forEach(col => {
        omitMap[col.id ?? col.name] = col.omit;
      });
      state.columnsTributation = state.columnsTributation.map(col => {
        const key = col.id ?? col.name;
        return key in omitMap ? { ...col, omit: omitMap[key] } : col;
      });
    },
    handleReorderAndUpdateColumns: (state, { payload }) => {
      // Colunas com cabeçalho JSX (RelatorioProdutosNovo) usam `id` como
      // chave estável — `name` não é string única nesse caso.
      const updatedMap = {};
      payload.forEach((col, idx) => {
        updatedMap[col.id ?? col.name] = { omit: col.omit, position: idx };
      });
      state.columnsTributation = state.columnsTributation
        .map(col => {
          const key = col.id ?? col.name;
          if (key && updatedMap[key] !== undefined) {
            return {
              ...col,
              omit: updatedMap[key].omit,
              position: updatedMap[key].position,
            };
          }
          return col;
        })
        .sort((a, b) => a.position - b.position);
      state.isUpdateColumns = true;
    },
  },
});

export const {
  handleParams,
  handleParamsClear,
  handleParamsClearIn,
  handleParamsSearch,
  handleSetColumnsTributation,
  handleOnChangeColumns,
  handleToggleColumnsOmit,
  handleReorderAndUpdateColumns,
} = relatorioCfopSlice.actions;

export default relatorioCfopSlice.reducer;
